import { type FC } from 'react';
import { ContentModal } from './ContentModal';
import { Link } from '../Link';

type LearnHowSection =
  | {
      type: 'paragraph';
      content: string;
      links: Array<{ label: string; url: string }>;
      contentAfter: string;
    }
  | {
      type: 'list';
      content: string;
      items: Array<{ label: string; url: string }>;
    };

export type LearnHowPopupProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  sections: LearnHowSection[];
  buttonLabel: string;
};

export const LearnHowPopup: FC<LearnHowPopupProps> = ({
  isOpen,
  onClose,
  title,
  sections,
  buttonLabel,
}) => {
  return (
    <ContentModal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      buttonText={buttonLabel}
      onButtonClick={onClose}
    >
      {sections.map((section, i) => (
        <div key={i}>
          {section.type === 'paragraph' ? (
            <p>
              {section.content}
              {section.links.map((link, j) => (
                <span key={j}>
                  {j > 0 && ' and '}
                  <Link href={link.url} target="_blank" rel="noopener noreferrer">
                    {link.label}
                  </Link>
                </span>
              ))}
              {section.contentAfter}
            </p>
          ) : (
            <>
              <p>{section.content}</p>
              <ul>
                {section.items.map((item, j) => (
                  <li key={j}>
                    <Link href={item.url} target="_blank" rel="noopener noreferrer">
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </>
          )}
        </div>
      ))}
    </ContentModal>
  );
};
